document.addEventListener('DOMContentLoaded',()=>{
  const els=document.querySelectorAll('.ck-reveal');
  if(!('IntersectionObserver'in window)){els.forEach(e=>e.classList.add('visible'));}
  else{
    const io=new IntersectionObserver((entries)=>{entries.forEach(en=>{if(en.isIntersecting){en.target.classList.add('visible');io.unobserve(en.target)}})},{threshold:.14});
    els.forEach(e=>io.observe(e));
  }

  // CK Play Reel modal. Supports direct MP4/WebM/MOV URLs; external links open normally.
  const play=document.querySelector('.ck-play[data-ck-video]');
  if(play){
    const url=(play.getAttribute('data-ck-video')||'').trim();
    const isVideo=/\.(mp4|webm|mov)(\?.*)?$/i.test(url);
    if(isVideo){
      play.addEventListener('click',(ev)=>{
        ev.preventDefault();
        let modal=document.querySelector('.ck-video-modal');
        if(!modal){
          modal=document.createElement('div');
          modal.className='ck-video-modal';
          modal.innerHTML='<div class="ck-video-modal__inner"><button class="ck-video-modal__close" type="button" aria-label="Close video">×</button><video controls autoplay playsinline src=""></video></div>';
          document.body.appendChild(modal);
          modal.querySelector('.ck-video-modal__close').addEventListener('click',()=>{
            modal.classList.remove('is-open');
            const v=modal.querySelector('video'); if(v){v.pause(); v.removeAttribute('src'); v.load();}
          });
          modal.addEventListener('click',(e)=>{ if(e.target===modal) modal.querySelector('.ck-video-modal__close').click(); });
        }
        const v=modal.querySelector('video');
        v.src=url;
        modal.classList.add('is-open');
        v.play().catch(()=>{});
      });
    }else if(url===''){
      play.style.display='none';
    }
  }
});
